module.exports = __webpack_public_path__ + "yt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/yt.svg
// module id = 894
// module chunks = 0